import { NotificationMessageDto, NotificationMessageType } from '@/types/webapi';

/**
 * Sorting function that sorts notification messages from most severe to least severe.
 * To be used with Array.sort() or Array.toSorted()
 * @param a
 * @param b
 * @returns -1, 0, 1
 */
export function sortBySeverity(a: NotificationMessageDto, b: NotificationMessageDto) {
    if (!a && !b) return 0;
    if (!a) return -1;
    if (!b) return 1;

    // if type is equal
    if (a.type === b.type) return 0;

    // order is Cancellation > Deviation > Warning > BookingConfirmation > BookingArrangement > everything else
    let result = 0;

    result += getTypeWeight(a.type);
    result -= getTypeWeight(b.type);

    return Math.max(-1, Math.min(1, result));
}

function getTypeWeight(type: NotificationMessageType) {
    switch (type) {
        case NotificationMessageType.Cancellation:
            return -5;
        case NotificationMessageType.Deviation:
            return -4;
        case NotificationMessageType.Warning:
            return -3;
        case NotificationMessageType.BookingConfirmation:
            return -2;
        case NotificationMessageType.BookingArrangement:
            return -1;
        default:
            return 0;
    }
}

/**
 * Returns color code based on notification type.
 * @param type Notification type
 * @returns Hex color code
 */
export function getNotificationColor(type?: NotificationMessageType) {
    switch (type) {
        case NotificationMessageType.Warning:
            return '#d27e00';
        case NotificationMessageType.Deviation:
            return '#f7bc00';
        case NotificationMessageType.Cancellation:
            return '#ff3d00';
        default:
            return 'green';
    }
}
